const langCodeRegExp = /^([a-z]{2})(-[A-Z]{2})?$/;
export function getTwoLetterLangCode(langCode: string): string | undefined {
  return (langCodeRegExp.exec(langCode) ?? [])[1];
}
